import { render, staticRenderFns } from "./propertyInit.vue?vue&type=template&id=682a9056&scoped=true"
import script from "./propertyInit.vue?vue&type=script&lang=js"
export * from "./propertyInit.vue?vue&type=script&lang=js"
import style0 from "./propertyInit.vue?vue&type=style&index=0&id=682a9056&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a9056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682a9056')) {
      api.createRecord('682a9056', component.options)
    } else {
      api.reload('682a9056', component.options)
    }
    module.hot.accept("./propertyInit.vue?vue&type=template&id=682a9056&scoped=true", function () {
      api.rerender('682a9056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemInit/propertyInit/propertyInit.vue"
export default component.exports